if (!customElements.get('compare-price-disclosure')) {
  let nextId = 0;
  customElements.define('compare-price-disclosure', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.panel = this.querySelector('.compare-price-popover');
      if (!this.button || !this.panel) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panel.id = `compare-price-disclosure-${++nextId}`;
      this.panel.setAttribute('role', 'region');
      this.panel.setAttribute('aria-label', this.button.getAttribute('aria-label'));
      this.button.setAttribute('aria-controls', this.panel.id);
      this.close();
      this.button.addEventListener('click', () => {
        if (this.panel.hidden) {
          this.panel.hidden = false;
          this.button.setAttribute('aria-expanded', 'true');
          this.position();
        } else this.close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          this.close();
          this.button.focus();
        }
      }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }, options);
      window.addEventListener('resize', () => this.close(), options);
      document.addEventListener('scroll', event => {
        if (!this.panel.contains(event.target)) this.close();
      }, { capture: true, passive: true, signal: this.abort.signal });
    }
    close() {
      if (!this.panel || !this.button) return;
      this.panel.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
    }
    position() {
      const anchor = this.button.getBoundingClientRect();
      const width = this.panel.offsetWidth;
      const height = this.panel.offsetHeight;
      const left = Math.max(12, Math.min(anchor.right - width, window.innerWidth - width - 12));
      const below = anchor.bottom + 8;
      const top = below + height <= window.innerHeight - 12
        ? below : Math.max(12, anchor.top - height - 8);
      this.panel.style.left = `${left}px`;
      this.panel.style.top = `${top}px`;
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}